import React, { Component } from 'react'; // eslint-disable-line
import EditableLabel from '../forms/EditableLabel';

class ProjectTitle extends Component {
    constructor(props) {
        super(props);
        this.projectTitleChanged = this.projectTitleChanged.bind(this);
        this.switchState = this.switchState.bind(this);
        this.state = {
            inputEditState: false,
        };
    }

    projectTitleChanged(e) {
        const { version } = this.props;
        if (e.target.value !== '') {
            version.name = e.target.value;
        }
        this.props.updateTitle(version.name);
    }

    switchState(state) {
        this.setState({ inputEditState: state });
    }

    render() {
        return (
            <div className={this.state.inputEditState ? 'edit-active' : 'edit-inactive'}>
                {' '}
                <EditableLabel
                    id={this.props.id}
                    placeholder={this.props.name}
                    switchState={this.switchState}
                    onChange={this.projectTitleChanged}
                    value={this.props.name}
                />
            </div>
        );
    }
}

export default ProjectTitle;
